import BasicCoupon from "./components/BasicCoupon";
import CoverPage from "./components/CoverPage";

const CouponBook = ({ coupons, couponData }) => {
  return (
    <div id="print-area" className="coupon-book size-a6">
      <CoverPage
        theme={couponData.theme}
        title={couponData.title}
        subtitle={couponData.subtitle}
        forName={couponData.redeemable_by}
      />
      {coupons.map((coupon, i) => (
        <BasicCoupon
          key={i}
          redeemableBy={couponData.redeemable_by}
          number={i + 1}
          signature={couponData.from}
          theme={couponData.theme}
          handwritten={couponData.handwritten}
          {...coupon}
        />
      ))}
    </div>
  );
};

export default CouponBook;